import React, { useEffect, useState } from "react";
import { Button, Form, Col, Row, Tabs, Tab, Modal } from "react-bootstrap";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../_metronic/_partials/controls";
import { LayoutSplashScreen } from "../../../_metronic/layout";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import {
  allDate,
  allMonth,
  getValueType,
  iconError,
  showDialog,
  showErrorDialog,
  showSuccessDialog,
} from "../../utility";
import BootstrapTable from "react-bootstrap-table-next";
import Select from "react-select";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";
import {
  fetchParameter,
  fetchParameter2,
  selectCountry,
  selectParameter,
  selectParameter2,
  selectParameter3,
  selectParameter4,
  selectPhoneType,
} from "../businessParameter/businessParameterSlice";
// MUI
import { makeStyles, fade } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import {
  FilledInput,
  FormControl,
  FormHelperText,
  InputLabel,
  ThemeProvider,
  createMuiTheme,
} from "@material-ui/core";
import SelectMUI from "@material-ui/core/Select";
import { Autocomplete } from "@material-ui/lab";
import { addProductMaster } from "./ProductRelatedSlice";
import { ModalModelSelect } from "./ModalModelSelect";
import { ModalColorSelect } from "./ModalColorSelect";

const useStylesReddit = makeStyles((theme) => ({
  root: {
    border: "1px solid #e2e2e1",
    overflow: "hidden",
    borderRadius: 4,
    backgroundColor: "#FFFFFF",
    transition: theme.transitions.create(["border-color", "box-shadow"]),
    "&:hover": {
      backgroundColor: "#fff",
    },
    "&$focused": {
      backgroundColor: "#fff",
      boxShadow: `${fade(theme.palette.primary.main, 0.25)} 0 0 0 2px`,
      borderColor: theme.palette.primary.main,
    },
  },
  focused: {},
}));

const formLabelsTheme = createMuiTheme({
  overrides: {
    MuiFormLabel: {
      asterisk: {
        color: "#db3131",
        "&$error": {
          color: "#db3131",
        },
      },
    },
    MuiFormHelperText: {
      root: {
        margin: "1px !important", // Remove the margin
      },
    },
  },
  typography: {
    fontFamily: `"Poppins", "Helvetica", "Arial", sans-serif`,
  },
});
function RedditTextField(props) {
  const classes = useStylesReddit();

  return (
    <TextField InputProps={{ classes, disableUnderline: true }} {...props} />
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexWrap: "wrap",
  },
  margin: {
    margin: theme.spacing(1),
  },
}));

export const ProductMasterCreate = ({
  isOpen,
  handleShow,
  formValues,
  setFormValues,
  setShow,
  setShowModel,
  showModel,
  setShowColor,
  showColor,
  setFieldsModel,
  fieldsModel,
  setFieldsColor,
  fieldsColor,
  btnHide,
  setBtnHide,
}) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  const dataVolume = useSelector(selectParameter);
  const dataWeigth = useSelector(selectParameter2);
  const dataUom = useSelector(selectParameter3);
  const dataDistance = useSelector(selectParameter4);

  const handleClose = () => setShow(false);

  const validatePost = (e) => {
    let isValid = true;

    const formFields = Object.keys(formValues);
    let newFormValues = { ...formValues };

    for (let index = 0; index < formFields.length; index++) {
      const currentField = formFields[index];
      const currentValue = formValues[currentField].value;
      const required = formValues[currentField].required;

      if (currentValue === "" && required === "Y") {
        newFormValues = {
          ...newFormValues,
          [currentField]: {
            ...newFormValues[currentField],
            error: true,
          },
        };
        isValid = false;
      } else {
        newFormValues = {
          ...newFormValues,
          [currentField]: {
            ...newFormValues[currentField],
            error: false,
          },
        };
      }
    }

    setFormValues(newFormValues);
    return isValid;
  };

  const handleSave = async () => {
    if (
      formValues.product_code.value.includes("<script>") ||
      formValues.product_code.value.includes("</script>")
    ) {
      return showErrorDialog("please don't input value <script>");
    }

    if (
      formValues.product_name.value.includes("<script>") ||
      formValues.product_name.value.includes("</script>")
    ) {
      return showErrorDialog("please don't input value <script>");
    }

    if (!validatePost()) {
      return;
    }
    const params = {
      product_code: formValues.product_code.value,
      product_name: formValues.product_name.value,
      product_model: formValues.product_model.value,
      product_color: formValues.product_color.value,
      product_baseuom: formValues.product_baseuom.value,
      product_netweight: formValues.product_netweight.value,
      product_grossweight: formValues.product_grossweight.value,
      product_weighttype: formValues.product_weighttype.value,
      product_volume: formValues.product_volume.value,
      product_volumetype: formValues.product_volumetype.value,
      product_length: formValues.product_length.value,
      product_width: formValues.product_width.value,
      product_heigth: formValues.product_heigth.value,
      product_dimensiontype: formValues.product_dimensiontype.value,
    };

    try {
      const response = await dispatch(addProductMaster(params));
      if (response.payload.status === 200) {
        const action = await showSuccessDialog(response.payload.data.message);
        if (action.isConfirmed)
          await history.push(
            `/master/product-related/product-master/edit/${response.payload.data.data.product_id}`
          );
      } else {
        showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues({
      ...formValues,
      [name]: {
        ...formValues[name],
        value,
      },
    });
  };

  const volumeOptions = dataVolume.map((e) => {
    return {
      value: e.param_code,
      label: e.param_value,
    };
  });

  const handleChangeVolume = (e) => {
    const value = e.value;
    setFormValues({
      ...formValues,
      ["product_volumetype"]: {
        ...formValues["product_volumetype"],
        value,
      },
    });
  };

  const uomOptions = dataUom.map((e) => {
    return {
      value: e.param_code,
      label: e.param_value,
    };
  });

  const handleChangeUom = (e, params) => {
    const value = params.value;
    setFormValues({
      ...formValues,
      ["product_baseuom"]: {
        ...formValues["product_baseuom"],
        value,
      },
    });
  };

  const weigthOptions = dataWeigth.map((e) => {
    return {
      value: e.param_code,
      label: e.param_value,
    };
  });

  const distanceOptions = dataDistance.map((e) => {
    return {
      value: e.param_code,
      label: e.param_value,
    };
  });
  const handleChangeDistance = (e) => {
    const value = e.value;
    setFormValues({
      ...formValues,
      ["product_dimensiontype"]: {
        ...formValues["product_dimensiontype"],
        value,
      },
    });
  };

  const handleChangeWeigth = (e, params) => {
    const value = e.value;
    setFormValues({
      ...formValues,
      ["product_weighttype"]: {
        ...formValues["product_weighttype"],
        value,
      },
    });
  };

  const indexUom = uomOptions.findIndex(
    (obj) => obj.value === formValues.product_baseuom.value
  );

  return (
    <>
      <Modal
        size="xl"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={isOpen}
        onHide={handleClose}
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter text-white">
            New Product Master
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ThemeProvider theme={formLabelsTheme}>
            <div>
              <p className="font-weight-boldest">Basic Details</p>
              <Row>
                <Col xs={12} sm={3} md={6} lg={6}>
                  <RedditTextField
                    required
                    label="Code"
                    className={classes.margin}
                    variant="filled"
                    id="reddit-input"
                    size="small"
                    fullWidth
                    name="product_code"
                    value={formValues.product_code.value}
                    onChange={handleChange}
                    error={formValues.product_code.error}
                    helperText={
                      formValues.product_code.error ? (
                        <FormHelperText sx={{ mt: "5px", mb: "-10px" }}>
                          {iconError} {"This field is required"}
                        </FormHelperText>
                      ) : (
                        ""
                      )
                    }
                  />

                  <RedditTextField
                    required
                    label="Name"
                    className={classes.margin}
                    variant="filled"
                    id="reddit-input"
                    size="small"
                    fullWidth
                    name="product_name"
                    value={formValues.product_name.value}
                    onChange={handleChange}
                    error={formValues.product_name.error}
                    helperText={
                      formValues.product_name.error ? (
                        <FormHelperText sx={{ mt: "5px", mb: "-10px" }}>
                          {iconError} {"This field is required"}
                        </FormHelperText>
                      ) : (
                        ""
                      )
                    }
                  />
                </Col>
                <Col xs={12} sm={3} md={6} lg={6}>
                  <Row>
                    <Col xs={10} sm={3} md={9} lg={9}>
                      <RedditTextField
                        label="Model"
                        className={classes.margin}
                        variant="filled"
                        id="reddit-input"
                        size="small"
                        fullWidth
                        readOnly
                        value={formValues.product_model_name.value}
                        error={formValues.product_model.error}
                        helperText={
                          formValues.product_model.error ? (
                            <FormHelperText sx={{ mt: "5px", mb: "-10px" }}>
                              {iconError} {"This field is required"}
                            </FormHelperText>
                          ) : (
                            ""
                          )
                        }
                      />
                    </Col>
                    <Col>
                      <div>
                        <a className=" display-flex btn btn-icon btn-primary btn-hover-primary btn-sm mr-3 mt-5">
                          <span
                            className="svg-icon svg-icon-md svg-icon-light"
                            onClick={() => setShowModel(true)}
                          >
                            <SVG
                              src={toAbsoluteUrl(
                                "/media/svg/icons/New/Search.svg"
                              )}
                            />
                          </span>
                        </a>
                      </div>
                    </Col>
                  </Row>

                  <Row>
                    <Col xs={10} sm={3} md={9} lg={9}>
                      <RedditTextField
                        label="Color"
                        className={classes.margin}
                        variant="filled"
                        id="reddit-input"
                        size="small"
                        fullWidth
                        readOnly
                        value={formValues.product_color_name.value}
                        error={formValues.product_color.error}
                        helperText={
                          formValues.product_color.error ? (
                            <FormHelperText sx={{ mt: "5px", mb: "-10px" }}>
                              {iconError} {"This field is required"}
                            </FormHelperText>
                          ) : (
                            ""
                          )
                        }
                      />
                    </Col>
                    <Col>
                      <div>
                        <a className=" display-flex btn btn-icon btn-primary btn-hover-primary btn-sm mr-3 mt-5">
                          <span
                            className="svg-icon svg-icon-md svg-icon-light"
                            onClick={() => setShowColor(true)}
                          >
                            <SVG
                              src={toAbsoluteUrl(
                                "/media/svg/icons/New/Search.svg"
                              )}
                            />
                          </span>
                        </a>
                      </div>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </div>
            <hr />
            <div>
              <p className="font-weight-boldest">Weight & Measurement</p>
              <Row>
                <Col xs={12} sm={3} md={6} lg={6}>
                  <Autocomplete
                    disablePortal
                    name="product_baseuom"
                    options={uomOptions}
                    getOptionLabel={(option) => option.label.toString()}
                    disableClearable={true}
                    onChange={handleChangeUom}
                    value={uomOptions[indexUom]}
                    renderInput={(params) => (
                      <RedditTextField
                        required
                        className={classes.margin}
                        {...params}
                        label="Base UOM"
                        id="reddit-input"
                        size="small"
                        fullWidth
                        placeholder="Select UOM"
                        name="product_baseuom"
                        error={formValues.product_baseuom.error}
                        helperText={
                          formValues.product_baseuom.error ? (
                            <FormHelperText sx={{ mt: "5px", mb: "-10px" }}>
                              {iconError} {"This field is required"}
                            </FormHelperText>
                          ) : (
                            ""
                          )
                        }
                      />
                    )}
                  />
                </Col>
                <Col xs={12} sm={3} md={6} lg={6}>
                  <Row>
                    <Col md={4}>
                      <RedditTextField
                        label="Net Weight"
                        className={classes.margin}
                        variant="filled"
                        id="reddit-input"
                        size="small"
                        fullWidth
                        type="number"
                        name="product_netweight"
                        value={formValues.product_netweight.value}
                        onChange={handleChange}
                      />
                    </Col>
                    <Col md={4}>
                      <RedditTextField
                        label="Gross Weight"
                        className={classes.margin}
                        variant="filled"
                        id="reddit-input"
                        size="small"
                        fullWidth
                        type="number"
                        name="product_grossweight"
                        value={formValues.product_grossweight.value}
                        onChange={handleChange}
                      />
                    </Col>
                    <Col md={4}>
                      <Select
                        options={weigthOptions}
                        value={getValueType(
                          formValues.product_weighttype.value,
                          weigthOptions
                        )}
                        placeholder="Type"
                        onChange={handleChangeWeigth}
                        className="mt-4 "
                      />
                    </Col>
                  </Row>
                </Col>
              </Row>
            </div>
            <div>
              <p className="font-weight-boldest">Dimension</p>
              <Row>
                <Col xs={12} sm={3} md={3} lg={3}>
                  <RedditTextField
                    label="Length"
                    className={classes.margin}
                    variant="filled"
                    id="reddit-input"
                    size="small"
                    fullWidth
                    type="number"
                    name="product_length"
                    value={formValues.product_length.value}
                    onChange={handleChange}
                  />
                </Col>
                <p className="font-weight-boldest ml-4 mt-7">X</p>
                <Col xs={12} sm={3} md={3} lg={3}>
                  <RedditTextField
                    label="Width"
                    className={classes.margin}
                    variant="filled"
                    id="reddit-input"
                    size="small"
                    fullWidth
                    type="number"
                    name="product_width"
                    value={formValues.product_width.value}
                    onChange={handleChange}
                  />
                </Col>
                <p className="font-weight-boldest ml-4 mt-7">X</p>
                <Col xs={12} sm={3} md={3} lg={3}>
                  <RedditTextField
                    label="Heigth"
                    className={classes.margin}
                    variant="filled"
                    id="reddit-input"
                    size="small"
                    fullWidth
                    type="number"
                    name="product_heigth"
                    value={formValues.product_heigth.value}
                    onChange={handleChange}
                  />
                </Col>
                <Col>
                  <Select
                    options={distanceOptions}
                    value={getValueType(
                      formValues.product_dimensiontype.value,
                      distanceOptions
                    )}
                    onChange={handleChangeDistance}
                    className="mt-4 ml-3"
                  />
                </Col>
              </Row>
              <Row>
                <Col md={4}>
                  <RedditTextField
                    label="Volume"
                    className={classes.margin}
                    variant="filled"
                    id="reddit-input"
                    size="small"
                    fullWidth
                    type="number"
                    name="product_volume"
                    value={formValues.product_volume.value}
                    onChange={handleChange}
                  />
                </Col>

                <Col md={3}>
                  <Select
                    // isClearable={true}
                    options={volumeOptions}
                    value={getValueType(
                      formValues.product_volumetype.value,
                      volumeOptions
                    )}
                    // placeholder="Type"
                    onChange={handleChangeVolume}
                    className="mt-4 "
                  />
                </Col>
              </Row>
            </div>
          </ThemeProvider>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button variant="primary" onClick={handleSave}>
            Save
          </Button>
        </Modal.Footer>
      </Modal>

      <ModalModelSelect
        isOpen={showModel}
        setShow={setShowModel}
        setFormValues={setFormValues}
        formValues={formValues}
        setFields={setFieldsModel}
        fields={fieldsModel}
        btnHide={btnHide}
        setBtnHide={setBtnHide}
      />
      <ModalColorSelect
        isOpen={showColor}
        setShow={setShowColor}
        setFormValues={setFormValues}
        formValues={formValues}
        setFields={setFieldsColor}
        fields={fieldsColor}
      />
    </>
  );
};
